import React, { useContext } from "react";
import Footer from "./Footer";
import Head from "../containers/Head";
import RenderSvg from "./RenderSvg";
import GlobalConfig from "../context/GlobalConfig";
import { languageData } from "../constants/languageData";

function LivenessAnalysing( stepperFunc ) {
  const { config } = useContext(GlobalConfig);
  const language = sessionStorage.getItem("language") ?? "en";

  return (
    <>
      <Head
        style={{ zIndex: "100" }}
        stepperFunc={stepperFunc}
        showLanguages={false}
        showBackIcon={false}
        showHelp={false}
        showMobileFlow={false}
      />
      <div className="parent-container">
        <div className="main">
          <div className="left-section">
            <RenderSvg
              config={config}
              id={"analusing"}
              svgType={"analysing"}
              className="w-[180px] h-[180px] md:w-[200px] md:h-[200px] md:relative fixed"
              style={{ marginTop: "3rem" }}
            />
          </div>

          <div
            className="right-section md:items-start items-center"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              gap: 24,
              fontFamily: "Inter, sans-serif",
            }}
          >
            <div className="flex flex-col">
              <div style={{flexWrap:'wrap'}} className="text-[18px] md:text-[26px] flex items-baseline font-semibold text-[#000000] md:justify-start justify-center md:text-left mt-4 md:mt-0">
                {languageData[language]?.livenessAnalyzing?.heading ??
                  languageData["en"]?.analyzing?.heading}
                <span class="dot-loader ml-2 mt-4"></span>
              </div>
              <div className="md:mt-4 md:mb-4 mt-6 mb-6 text-[12px] md:text-[16px] font-semibold text-[#656565] text-center md:text-left">
                {languageData[language]?.analyzing?.subHeading ??
                  languageData["en"]?.analyzing?.heading}
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default LivenessAnalysing;
